import { FC } from "react";
import { Link } from "react-router-dom";

interface AdminPaginationProps {
    page?: number;
    pageSize?: number;
    total?: number;
}

const AdminPagination: FC<AdminPaginationProps> = ({ page = 1, pageSize = 10, total = 0 }) => {
    const totalPages = Math.ceil(total / pageSize);
    const currentPage = Math.min(Math.max(1, page), totalPages);

    if (totalPages <= 1) return null;

    const getPageNumbers = () => {
        const pages: (number | "...")[] = [];

        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            pages.push(1);

            if (currentPage > 4) {
                pages.push("...");
            }

            const start = Math.max(2, currentPage - 1);
            const end = Math.min(totalPages - 1, currentPage + 1);

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            if (currentPage < totalPages - 3) {
                pages.push("...");
            }

            pages.push(totalPages);
        }

        return pages;
    };

    const pageNumbers = getPageNumbers();

    const buildLink = (p: number) => `?page=${p}&pageSize=${pageSize}`;

    return (
        <div className="mt-6 flex justify-center">
            <nav className="flex items-center space-x-2 text-sm">
                <Link
                    to={buildLink(currentPage - 1)}
                    className={`px-3 py-1.5 border rounded hover:bg-gray-100 ${currentPage === 1 ? "pointer-events-none text-gray-300 border-gray-200" : "border-gray-300 text-gray-500"
                        }`}
                >
                    «
                </Link>

                {pageNumbers.map((p, idx) =>
                    p === "..." ? (
                        <span key={idx} className="px-3 py-1.5 text-gray-400">
                            ...
                        </span>
                    ) : (
                        <Link
                            key={idx}
                            to={buildLink(p)}
                            className={`px-3 py-1.5 border rounded ${p === currentPage
                                ? "border-blue-600 text-blue-600 font-semibold"
                                : "border-gray-300 text-gray-700 hover:bg-gray-100"
                                }`}
                        >
                            {p}
                        </Link>
                    )
                )}

                <Link
                    to={buildLink(currentPage + 1)}
                    className={`px-3 py-1.5 border rounded hover:bg-gray-100 ${currentPage === totalPages ? "pointer-events-none text-gray-300 border-gray-200" : "border-gray-300 text-gray-500"
                        }`}
                >
                    »
                </Link>
            </nav>
        </div>
    );
};

export default AdminPagination;
